import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tipoCanchas: [],
  fetchTipoCanchasLoading: false,
  fetchTipoCanchasError: null,

  tipoCancha: {},
  fetchTipoCanchaLoading: false,
  fetchTipoCanchaError: null,

  addTipoCanchaLoading: false,
  addTipoCanchaError: null,

  updateTipoCanchaLoading: false,
  updateTipoCanchaError: null,

  deleteTipoCanchaLoading: false,
  deleteTipoCanchaError: null
};

export const tipoCanchasSlice = createSlice({
  name: 'TIPOCANCHAS',
  initialState,
  reducers: {
    fetchTipoCanchasStart: state => {
      state.fetchTipoCanchasLoading = true;
      state.fetchTipoCanchasError = null;
    },
    fetchTipoCanchasSuccess: (state, action) => {
      state.fetchTipoCanchasLoading = false;
      state.tipoCanchas = action.payload;
    },
    fetchTipoCanchassError: (state, action) => {
      state.fetchTipoCanchasLoading = false;
      state.fetchTipoCanchasError = action.payload;
    },

    fetchTipoCanchaStart: state => {
      state.fetchTipoCanchaLoading = true;
      state.fetchTipoCanchaError = null;
    },
    fetchTipoCanchaSuccess: (state, action) => {
      state.fetchTipoCanchaLoading = false;
      state.tipoCancha = action.payload;
    },
    fetchTipoCanchaError: (state, action) => {
      state.fetchTipoCanchaLoading = false;
      state.fetchTipoCanchaError = action.payload;
    },

    addTipoCanchaStart: state => {
      state.addTipoCanchaLoading = true;
      state.addTipoCanchaError = null;
    },
    addTipoCanchaSuccess: (state, action) => {
      state.addTipoCanchaLoading = false;
      state.tipoCanchas.unshift(action.payload);
    },
    addTipoCanchaError: (state, action) => {
      state.addTipoCanchaLoading = false;
      state.addTipoCanchaError = action.payload;
    },

    updateTipoCanchaStart: state => {
      state.updateTipoCanchaLoading = true;
      state.updateTipoCanchaError = null;
    },
    updateTipoCanchaSuccess: (state, action) => {
      state.updateTipoCanchaLoading = false;
      const newState = state.tipoCanchas.map(tipoCan => {
        if (tipoCan.id === action.payload.id) return action.payload;
        return tipoCan;
      });
      state.tipoCanchas = newState;
    },
    updateTipoCanchaError: (state, action) => {
      state.updateTipoCanchaLoading = false;
      state.updateTipoCanchaError = action.payload;
    },

    deleteTipoCanchaStart: state => {
      state.deleteTipoCanchaLoading = true;
      state.deleteTipoCanchaError = null;
    },
    deleteTipoCanchaSuccess: (state, action) => {
      state.deleteTipoCanchaLoading = false;
      const newState = state.tipoCanchas.filter(
        tipoCan => tipoCan.id !== action.payload.id
      );
      state.tipoCanchas = newState;
    },
    deleteTipoCanchaError: (state, action) => {
      state.deleteTipoCanchaLoading = false;
      state.deleteTipoCanchaError = action.payload;
    }
  }
});

export const {
  fetchTipoCanchasStart,
  fetchTipoCanchasSuccess,
  fetchTipoCanchasError,
  fetchTipoCanchaStart,
  fetchTipoCanchaSuccess,
  fetchTipoCanchaError,
  addTipoCanchaStart,
  addTipoCanchaSuccess,
  addTipoCanchaError,
  updateTipoCanchaStart,
  updateTipoCanchaSuccess,
  updateTipoCanchaError,
  deleteTipoCanchaStart,
  deleteTipoCanchaSuccess,
  deleteTipoCanchaError
} = tipoCanchasSlice.actions;

export default tipoCanchasSlice.reducer;
